<header class="d-flex flex-column flex-lg-row align-items-start justify-content-between
  gap-3 gap-lg-4 flex-wrap py-3">
  <h3 class="fy-title mb-0">Federal FY {{ year.year }}</h3>

  <div class="d-flex flex-row align-items-start gap-3 gap-lg-4 flex-wrap">
    @for (series of seriesStats; track series.definition.key) {
      <div class="d-flex flex-column">
        <span [class]="'series-name d-flex flex-row align-items-center gap-1 ' + series.definition.key"
          [style.color]="series.definition.color">
          <span aria-hidden="true">{{ series.definition.icon }}</span> {{ series.definition.statLabel }}
        </span>
        <div class="d-flex flex-row gap-3">
          <div class="d-flex flex-column">
            <small class="stat-label">↓ Low</small>
            <strong class="stat-value">{{ format(series.low!) }}</strong>
          </div>
          <div class="d-flex flex-column">
            <small class="stat-label">↑ High</small>
            <strong class="stat-value">{{ format(series.high!) }}</strong>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="d-flex flex-column">
    <span class="series-name d-flex flex-row align-items-center gap-1">
      <span aria-hidden="true">🏦</span> Rates
    </span>
    <div class="d-flex flex-row gap-3">
      <div class="d-flex flex-column">
        <small class="stat-label increase">↗ Total hikes</small>
        <strong class="stat-value">{{ increaseCount }}</strong>
      </div>
      <div class="d-flex flex-column">
        <small class="stat-label decrease">↘ Total cuts</small>
        <strong class="stat-value">{{ decreaseCount }}</strong>
      </div>
      <div class="d-flex flex-column">
        <small class="stat-label">— No change</small>
        <strong class="stat-value">{{ noChangeCount }}</strong>
      </div>
      @if (year.upcomingCount > 0) {
        <div class="d-flex flex-column">
          <small class="stat-label">◷ Upcoming</small>
          <strong class="stat-value">{{ year.upcomingCount }}</strong>
        </div>
      }
    </div>
  </div>
</header>
